import React from "react";
import Slider from "./Slider";
import "../../styles/assets/css/landing/slider.css";

function Clients() {
  return (
    <>
      <div className="w-full flex justify-center ">
        <Slider />
      </div>
    </>
  );
}

export default Clients;
